export class AwsWafUtils {
  /**
   * Retrieves an AWS WAF token, ensuring the script is loaded and valid.
   * @throws {Error} if AwsWafIntegration is not available or token retrieval fails.
   */
  static async getToken(): Promise<string> {
    if (typeof window === 'undefined') {
      throw new Error('window is not available (not running in browser)')
    }

    const integration = window.AwsWafIntegration

    if (!integration || typeof integration.getToken !== 'function') {
      throw new Error('AwsWafIntegration is not available or not properly initialized')
    }

    try {
      const token = await integration.getToken()
      if (!token || typeof token !== 'string') {
        throw new Error('Invalid token received from AwsWafIntegration')
      }
      return token
    } catch (err) {
      throw new Error('Failed to retrieve AWS WAF token: ' + (err instanceof Error ? err.message : String(err)))
    }
  }
}
